import { useEffect, useState } from 'react';

/** `value`, updated only after it has not changed for `delayMs`; keeps typing in a search box from firing a request per key. */
export const useDebouncedValue = <T>(value: T, delayMs = 300): T => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timeout = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timeout);
  }, [value, delayMs]);

  return debounced;
};
